<div>
    <ng-container *ngIf="inLoading">
        <mat-progress-bar color="warn" mode="indeterminate"></mat-progress-bar>
    </ng-container>    
    <table mat-table
        [dataSource]="sessionInfo" multiTemplateDataRows
        class="mat-elevation-z8">
    <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
        <th mat-header-cell *matHeaderCellDef> {{column}} </th>        
        <td mat-cell *matCellDef="let element">            
            <ng-container *ngIf="element[column]; else colNotFoundTemplate">{{element[column]}}</ng-container>
            <ng-template #colNotFoundTemplate [ngSwitch]="column">                
                <ng-container *ngSwitchCase="'Action'">
                    <button mat-raised-button [disabled]="lockInterface || element.Status == 'Closed'" color="warn" (click)="closeSession($event, element)">Withdraw</button>
                </ng-container>                
                <ng-container *ngSwitchCase="'Connected ?'">
                    {{element.LoggedUser.IsConnected}}
                </ng-container>
                <ng-container *ngSwitchDefault>Err: <br>{{column}} Not found</ng-container>
            </ng-template>
        </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">                
                <ng-container *ngIf="element.LoggedUser.IsConnected; else elseTemplate">                    
                    <div style="width: 100%;">
                        <mat-grid-list cols="4" rowHeight="25px" gutterSize="5px">
                            <mat-grid-tile colspan="4">Content of object TLoggedUser</mat-grid-tile>
                            <mat-grid-tile *ngFor="let item of toObjectInterface(element.LoggedUser); let i=index">
                                {{item[0]}} : {{item[1]}}
                            </mat-grid-tile>
                        </mat-grid-list>
                    </div>
                </ng-container>
                <ng-template #elseTemplate>
                    Session not logged...
                </ng-template>                
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
</div>    